module.exports = __webpack_public_path__ + "static/img/thumbnail-small.aa604f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/thumbnail-small.jpg
// module id = lvWI
// module chunks = 1